import { render } from "./Bill.vue?vue&type=template&id=66bd6f52&scoped=true"
import script from "./Bill.vue?vue&type=script&lang=js"
export * from "./Bill.vue?vue&type=script&lang=js"

import "./Bill.vue?vue&type=style&index=0&id=66bd6f52&scoped=true&lang=css"

import exportComponent from "E:\\zzh\\zl-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66bd6f52"]])

export default __exports__